module.exports = __webpack_public_path__ + "static/img/05.52a4caa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/alpa_bern/05.jpg
// module id = 354
// module chunks = 1